import { Icon } from '@tkww/orion-web-ds-graphic';
import React from 'react';
import type { ReactNode } from 'react';
import Styles from './styles.scss';

export interface BaseAppliedPillProps {
	/** Text or content to display in the pill */
	label: string | ReactNode;
	/** Handler called when the close button is clicked */
	onClose: () => void;
	/** Aria label for the close button */
	ariaLabel?: string;
	/** Additional CSS class for the pill container */
	className?: string;
}

/**
 * BaseAppliedPill - A generic applied filter pill component that displays
 * an active filter with a close button to remove it.
 */
export const BaseAppliedPill = ({
	label,
	onClose,
	ariaLabel = 'Remove filter',
	className,
}: BaseAppliedPillProps) => {
	return (
		<div className={`${Styles.pill} ${className || ''}`}>
			<span className={Styles.text}>{label}</span>
			<button
				type="button"
				onClick={onClose}
				className={Styles.closeBtn}
				aria-label={ariaLabel}
			>
				<Icon
					size="sm"
					name="close"
					aria-hidden={true}
					aria-label={undefined}
				/>
			</button>
		</div>
	);
};
